import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppInfo, Versions } from 'domain/AppInfo'
import { SearchAppInfo } from 'domain/SearchAppInfo'
import { AppCategory } from 'domain/AppCategory'
import { AppStatus } from 'domain/AppStatus'
import { SearchAppGrid } from 'domain/SearchAppGrid'

const appSlice = createSlice({
    name: 'appSlice',
    initialState: {
        isLoading: false,
        loadingProgress: -1,
        app: {
            isGame: false,
            isTablet: false,
            isTopApp: false,
        } as AppInfo,
        apps: [] as SearchAppInfo[],
        appsGrid: [] as SearchAppGrid[],
        appCategories: [] as AppCategory[],
        appStatuses: [] as AppStatus[],
        newApp: {
            isGame: false,
            isTablet: false,
            isTopApp: false,
        } as AppInfo,
        newApk: {
            is32bit: false,
            is64bit: false,
        } as Versions,
        file: {} as File,
        apks: [] as Versions[],
        apk: {} as Versions,
    },
    reducers: {
        setIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload
        },
        setLoadingProgress: (state, action: PayloadAction<number>) => {
            state.loadingProgress = action.payload
        },
        setApp: (state, action: PayloadAction<AppInfo>) => {
            state.app = action.payload
        },
        setApps: (state, action: PayloadAction<SearchAppInfo[]>) => {
            state.apps = action.payload
        },
        setAppsGrid: (state, action: PayloadAction<SearchAppGrid[]>) => {
            state.appsGrid = action.payload
        },
        setAppCategories: (state, action: PayloadAction<AppCategory[]>) => {
            state.appCategories = action.payload
        },
        setAppStatuses: (state, action: PayloadAction<AppStatus[]>) => {
            state.appStatuses = action.payload
        },
        updateApp: (state, action: PayloadAction<Partial<AppInfo>>) => {
            state.app = { ...state.app, ...action.payload }
        },
        updateNewApp: (state, action: PayloadAction<Partial<AppInfo>>) => {
            state.newApp = { ...state.newApp, ...action.payload }
        },
        clearNewApp: (state, action: PayloadAction<void>) => {
            state.newApp = {} as AppInfo
        },
        updateNewApk: (state, action: PayloadAction<Partial<Versions>>) => {
            state.newApk = { ...state.newApk, ...action.payload }
        },
        clearNewApk: (state, action: PayloadAction<void>) => {
            state.newApk = {
                is32bit: false,
                is64bit: false,
            } as Versions
        },
        setFile: (state, action: PayloadAction<File>) => {
            state.file = action.payload
        },
        setApks: (state, action: PayloadAction<Versions[]>) => {
            state.apks = action.payload
        },
        setApk: (state, action: PayloadAction<Versions>) => {
            state.apk = action.payload
        },
        updateApk: (state, action: PayloadAction<Partial<Versions>>) => {
            state.apk = { ...state.apk, ...action.payload }
        },
    },
})

export const {
    setIsLoading,
    setLoadingProgress,
    setApp,
    setApps,
    setAppsGrid,
    setAppCategories,
    setAppStatuses,
    updateApp,
    updateNewApp,
    clearNewApp,
    updateNewApk,
    clearNewApk,
    setFile,
    setApks,
    setApk,
    updateApk,
} = appSlice.actions
export default appSlice.reducer
